/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import BerbixVerify from 'berbix-react';
import { useDispatch } from 'react-redux';
import { submit } from 'redux-form';

const FORM_NAME = 'task';

export namespace BerbixIDV {
  export interface DispatchProps {}
  export interface OwnProps {
    opts: {
      task: {
        template: {
          customProps: {
            idvClientKey: string;
          };
        };
      };
    };
  }
  export interface StateProps {}

  export type Props = StateProps & DispatchProps & OwnProps;
}

export const BerbixIDV: React.FunctionComponent<BerbixIDV.Props> = ({ opts }) => {
  const dispatch = useDispatch();
  const clientToken = opts.task.template.customProps.idvClientKey;

  return (
    <div>
      <BerbixVerify
        showInModal={false}
        showCloseModalButton={false}
        clientToken={clientToken}
        onComplete={() => {
          dispatch(submit(FORM_NAME));
        }}
        onError={() => {
          dispatch(submit(FORM_NAME));
        }}
      />
    </div>
  );
};
